/**
 * AI 문장 다듬기 Inline Tool
 *
 * 에디터에서 텍스트 선택 시 인라인 툴바에 AI 버튼을 표시하고,
 * 클릭하면 AI Skills 패널을 열어 문장 다듬기를 실행합니다.
 */
import geminiSvg from '../../../../assets/images/gemini.svg?raw';

export default class AiPolishTool {
  static get isInline() {
    return true;
  }

  static get title() {
    return 'AI 문장 다듬기 — 선택한 텍스트를 자연스럽게 개선합니다';
  }

  constructor({ api }) {
    this.api = api;
  }

  render() {
    const button = document.createElement('button');
    button.type = 'button';
    button.classList.add('ce-inline-tool');
    button.style.padding = '4px';
    button.style.display = 'flex';
    button.style.alignItems = 'center';
    button.style.justifyContent = 'center';

    const wrapper = document.createElement('span');
    wrapper.style.width = '16px';
    wrapper.style.height = '16px';
    wrapper.style.display = 'flex';
    wrapper.innerHTML = geminiSvg;
    const svg = wrapper.querySelector('svg');
    if (svg) {
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
    }
    button.appendChild(wrapper);
    return button;
  }

  surround(range) {
    if (!range) return;

    const selectedText = range.toString().trim();
    if (!selectedText) return;

    // 선택 영역의 block index 찾기
    let blockIndex = -1;
    let node = range.startContainer;
    while (node && !node.classList?.contains('ce-block')) {
      node = node.parentElement;
    }
    if (node) {
      blockIndex = Array.from(document.querySelectorAll('.ce-block')).indexOf(node);
    }

    // AI Skills 패널 열기 + 문장 다듬기 실행 이벤트 디스패치
    window.dispatchEvent(new CustomEvent('ai-skills-open-and-run-polish', {
      detail: { text: selectedText, blockIndex }
    }));
  }

  checkState() {
    return false;
  }
}
